/**
 * 样式化消息提示框（纯内联样式，无外部依赖）
 * 替代浏览器原生 alert()
 */

let messageBoxContainer = null

function getContainer() {
  if (!messageBoxContainer) {
    messageBoxContainer = document.createElement('div')
    messageBoxContainer.id = 'message-box-container'
    messageBoxContainer.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);z-index:99999;display:flex;flex-direction:column;gap:10px;pointer-events:none;'
    document.body.appendChild(messageBoxContainer)
  }
  return messageBoxContainer
}

function showMessage(message, type = 'info', title = '提示') {
  const container = getContainer()
  const el = document.createElement('div')

  const colors = {
    success: { bg: '#d1fae5', border: '#6ee7b7', text: '#065f46', icon: '#10b981' },
    warning: { bg: '#fef3c7', border: '#fcd34d', text: '#92400e', icon: '#f59e0b' },
    error:   { bg: '#fee2e2', border: '#fca5a5', text: '#991b1b', icon: '#ef4444' },
    info:    { bg: '#dbeafe', border: '#93c5fd', text: '#1e40af', icon: '#3b82f6' }
  }
  const c = colors[type] || colors.info

  const iconMap = { success: '✓', warning: '⚠', error: '✕', info: 'ℹ' }

  el.style.cssText = `min-width:300px;max-width:500px;pointer-events:auto;margin:0;animation:slideDown 0.3s ease;display:flex;align-items:center;gap:10px;padding:12px 16px;border-radius:8px;background:${c.bg};border:1px solid ${c.border};box-shadow:0 4px 16px rgba(0,0,0,0.1);`
  el.innerHTML = `
    <span style="width:22px;height:22px;border-radius:50%;background:${c.icon};color:#fff;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;flex-shrink:0;">${iconMap[type] || 'ℹ'}</span>
    <div style="flex:1;min-width:0;">
      <div style="font-size:13px;font-weight:600;color:${c.text};margin-bottom:2px;">${title}</div>
      <div style="font-size:12px;color:${c.text};opacity:0.85;">${message}</div>
    </div>
    <button type="button" style="border:none;background:none;color:${c.text};opacity:0.5;cursor:pointer;font-size:16px;padding:0 4px;line-height:1;flex-shrink:0;">×</button>
  `

  container.appendChild(el)

  // 自动关闭
  const timer = setTimeout(() => {
    if (el.parentNode) {
      el.style.opacity = '0'
      el.style.transition = 'opacity 0.3s'
      setTimeout(() => el.remove(), 300)
    }
  }, 3000)

  // 手动关闭
  const closeBtn = el.querySelector('button')
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      clearTimeout(timer)
      el.style.opacity = '0'
      el.style.transition = 'opacity 0.3s'
      setTimeout(() => el.remove(), 300)
    })
  }
}

// 确认对话框
function showConfirm(message, title = '确认') {
  return new Promise((resolve) => {
    const overlay = document.createElement('div')
    overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.45);z-index:99998;display:flex;align-items:center;justify-content:center;animation:fadeIn 0.15s ease;'
    
    const dialog = document.createElement('div')
    dialog.style.cssText = 'width:380px;max-width:90vw;background:#fff;border-radius:8px;box-shadow:0 8px 32px rgba(0,0,0,0.2);animation:scaleIn 0.2s ease;overflow:hidden;'
    dialog.innerHTML = `
      <div style="padding:16px 20px;background:#f8f9fa;border-bottom:1px solid #e8e8e8;display:flex;align-items:center;justify-content:space-between;">
        <span style="font-size:15px;font-weight:600;color:#1f2937;">${title}</span>
        <button type="button" id="confirm-close" style="border:none;background:none;font-size:20px;color:#9ca3af;cursor:pointer;padding:0 4px;line-height:1;">×</button>
      </div>
      <div style="padding:20px;">
        <p style="margin:0;font-size:14px;color:#374151;line-height:1.6;">${message}</p>
      </div>
      <div style="padding:12px 20px;border-top:1px solid #e8e8e8;display:flex;justify-content:flex-end;gap:10px;">
        <button type="button" id="confirm-cancel" style="padding:7px 20px;border:1px solid #d1d5db;border-radius:6px;background:#fff;color:#374151;font-size:13px;cursor:pointer;transition:all .15s;">取消</button>
        <button type="button" id="confirm-ok" style="padding:7px 20px;border:none;border-radius:6px;background:#10b981;color:#fff;font-size:13px;font-weight:500;cursor:pointer;transition:all .15s;">确定</button>
      </div>
    `

    overlay.appendChild(dialog)
    document.body.appendChild(overlay)

    const cleanup = () => {
      overlay.style.opacity = '0'
      overlay.style.transition = 'opacity 0.15s'
      setTimeout(() => overlay.remove(), 150)
    }

    // 按钮 hover 效果
    const cancelBtn = dialog.querySelector('#confirm-cancel')
    const okBtn = dialog.querySelector('#confirm-ok')
    cancelBtn.addEventListener('mouseenter', () => { cancelBtn.style.background = '#f3f4f6'; cancelBtn.style.borderColor = '#9ca3af' })
    cancelBtn.addEventListener('mouseleave', () => { cancelBtn.style.background = '#fff'; cancelBtn.style.borderColor = '#d1d5db' })
    okBtn.addEventListener('mouseenter', () => { okBtn.style.background = '#059669' })
    okBtn.addEventListener('mouseleave', () => { okBtn.style.background = '#10b981' })

    okBtn.addEventListener('click', () => {
      cleanup()
      resolve(true)
    })

    cancelBtn.addEventListener('click', () => {
      cleanup()
      resolve(false)
    })

    dialog.querySelector('#confirm-close').addEventListener('click', () => {
      cleanup()
      resolve(false)
    })

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        cleanup()
        resolve(false)
      }
    })
  })
}

// 添加动画样式
if (!document.getElementById('message-box-styles')) {
  const style = document.createElement('style')
  style.id = 'message-box-styles'
  style.textContent = `
    @keyframes slideDown {
      from { opacity: 0; transform: translateY(-20px); }
      to { opacity: 1; transform: translateY(0); }
    }
    @keyframes scaleIn {
      from { opacity: 0; transform: scale(0.9); }
      to { opacity: 1; transform: scale(1); }
    }
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
  `
  document.head.appendChild(style)
}

export const ElMessageBox = {
  alert: (message, title = '提示', options = {}) => {
    const type = options.type || 'info'
    showMessage(message, type, title)
  },
  confirm: (message, title = '确认', options = {}) => {
    return showConfirm(message, title)
  }
}

export const ElMessage = {
  success: (message) => showMessage(message, 'success', '成功'),
  warning: (message) => showMessage(message, 'warning', '警告'),
  error: (message) => showMessage(message, 'error', '错误'),
  info: (message) => showMessage(message, 'info', '提示')
}
